
import {
    defineComponent, Prop, ref, Ref
} from 'vue';

export default defineComponent({
    props: {
        name: {
            type: String,
            required: true
        },
        active: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { emit }) {
        const showHaning = ref(false);
        return {
            showHaning,
            emit
        };
    }
});
